import sanitizeHtml from 'sanitize-html';

// Twin of the default allowlist in apps/api/lib/sanitize-user-html.ts, which
// cleans the text on save; this runs again where it is rendered, so the box
// never trusts a value that reached it by another route.
const OPTIONS = {
  allowedTags: ['a', 'b', 'strong', 'i', 'em', 'u', 's', 'br'],
  allowedAttributes: { a: ['href', 'target', 'rel'] },
  allowedSchemes: ['http', 'https', 'mailto', 'tel'],
  transformTags: {
    a: sanitizeHtml.simpleTransform('a', { target: '_blank', rel: 'noopener noreferrer' }),
  },
};

export default function sanitizeCalloutHtml(html) {
  if (typeof html !== 'string') return '';
  return sanitizeHtml(html, OPTIONS).trim();
}
